/**
 * Enum for widget type identifiers
 * These are the unique names used as CSS classes and widget identifiers
 */
export enum WidgetType {
  TASK_SUMMARY = 'task-summary',
  MY_TASKS = 'my-tasks',
  MY_INTERACTION_FEED = 'my-interaction-feed',
  INTERACTION_MENTION_FEED = 'interaction-mention-feed',
  UPCOMING_DEADLINES = 'upcoming-deadlines',
  UPCOMING_DEADLINES_TL = 'upcoming-deadlines-tl',
  MY_TIMESHEET_SUMMARY = 'my-timesheet-summary',
  APPROVALS = 'approvals',
  TEAM_OVERVIEW = 'team-overview',
  TEAM_LEADERBOARD = 'team-leaderboard',
  TEAM_WORKLOAD = 'team-workload',
  BILLABLE_UTILIZATION = 'billable-utilization',
  TIMESHEET_FOR_APPROVAL = 'timesheet-for-approval',
  DELIVERY_TIMELINE = 'delivery-timeline',
  TEAM_ATTENDANCE = 'team-attendance',
  QA_ISSUE_LIST = 'qa-issue-list',
  MY_REQUESTS = 'my-requests',
  WEEKLY_PROJECT_OVERVIEW = 'weekly-project-overview',
  DELIVERY_CALENDAR = 'delivery-calendar',
  PROJECTS_OVERVIEW = 'projects-overview',
  DELAYED_PROJECTS_OVERVIEW = 'delayed-projects-overview',
  PROJECTS_STATUS_CHART = 'projects-status-chart',
  PROJECT_BREAKDOWN_CATEGORY = 'project-breakdown-category',
  CAN_PM_SUMMARY = 'can-pm-summary',
  WORKLOAD_RESOURCE_CAPACITY_INTL = 'workload-resource-capacity-intl',
  // PROFITABILITY_SUMMARY_SETUP = 'profitability-summary-setup',
  PROFITABILITY_SUMMARY_RECURRING = 'profitability-summary-recurring',
  NEW_CLIENTS_SUMMARY = 'new-clients-summary',
  LOST_CLIENTS_SUMMARY = 'lost-clients-summary',
  AI_SAVED_HOURS_MONTHLY = 'ai-saved-hours-monthly',
  MEETING_GOAL_OVERVIEW = 'meeting-goal-overview',
  LEAD_PERFORMANCE_OVERVIEW = 'lead-performance-overview',
  BILLABLE_UTILIZATION_INTL = 'billable-utilization-intl',
  PROJECT_COMPLETION_DATE = 'project-completion-date',
  DEPARTMENT_HEAD_SUMMARY = 'department-head-summary',
  INTL_MANAGEMENT_SUMMARY = 'intl-management-summary',
  CAN_MANAGEMENT_SUMMARY = 'can-management-summary',
  CAN_AM_SUMMARY = 'can-am-summary'
}
